import { NgModule } from '@angular/core';

import { CmpsLazyRouterModule } from '../route.module';

import { CmpsReportBuilderModule } from './builder/builder.module';
import { ReportRoutes } from './report.route';
import { CmpsReportRunModule } from './run/run.module';

@NgModule({
    imports: [
        CmpsLazyRouterModule.forChild(ReportRoutes),
        CmpsReportBuilderModule,
        CmpsReportRunModule,
    ],
})
export class CmpsReportModule {}
